// @flow strict

import type {AgentApiParams} from 'src/types/scheduler/global.js';


export const SET_AGENT_API_PARAMS = 'scheduling/global/setAgentApiParams';

// action types
export type SchedulerGlobalActions = SetAgentApiParamsAction;

export type SetAgentApiParamsAction = {
  type: typeof SET_AGENT_API_PARAMS,
  payload: AgentApiParams,
};

export const setAgentApiParams = (
  payload: AgentApiParams,
): SetAgentApiParamsAction => ({
  type: SET_AGENT_API_PARAMS,
  payload,
});
